// AI Labs Configuration

// Admin email - this user gets admin privileges
export const ADMIN_EMAIL = 'ai@sedaily.com';

// Company domain for SSO
export const COMPANY_DOMAIN = 'sedaily.ai';
